/* this file is transformed by vux-loader */
/* eslint-disable */
import Cookies from 'js-cookie';

// User
var tokenKey = 'access_wuye_token_wx';
var openid = 'access_wuye_openid__wx';
export var getToken = function getToken() {
  return Cookies.get(tokenKey);
};
export var setToken = function setToken(token) {
  return Cookies.set(tokenKey, token);
};
export var removeToken = function removeToken() {
  return Cookies.remove(tokenKey);
};
export var getOpenid = function getOpenid() {
  return Cookies.get(openid);
};
export var setOpenid = function setOpenid(token) {
  return Cookies.set(openid, token);
};
export var removeOpenid = function removeOpenid() {
  return Cookies.remove(openid);
};